import { StoreSlice } from "../types/StoreSlice";

export interface INotificationSlice {
  savedNotificationOpen: boolean;
  failedNotificationOpen: boolean;
  message?: string;
  errorMessage?: string;

  savedNotification: (message: string) => void;
  failedNotification: (message: string, errorMessage: string) => void;
  closeNotifications: () => void;

  storageFacilityCityWarning: boolean;
  setStorageFacilityCityWarning: (value: boolean) => void;
  storageFacilityStateWarning: boolean;
  setStorageFacilityStateWarning: (value: boolean) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createNotificationSlice: StoreSlice<INotificationSlice> = (
  set
) => {
  const initialState = {
    savedNotificationOpen: false,
    failedNotificationOpen: false,
    message: undefined,
    errorMessage: undefined,

    storageFacilityCityWarning: false,
    storageFacilityStateWarning: false,
  };

  return {
    ...initialState,
    savedNotification: (message: string) => {
      set({ savedNotificationOpen: true, message });
    },
    failedNotification: (message: string, errorMessage: string) => {
      set({ failedNotificationOpen: true, message, errorMessage });
    },
    closeNotifications: () => {
      set({
        savedNotificationOpen: false,
        failedNotificationOpen: false,
        message: undefined,
        errorMessage: undefined,
      });
    },

    setStorageFacilityCityWarning: (value: boolean) => {
      set({ storageFacilityCityWarning: value });
    },
    setStorageFacilityStateWarning: (value: boolean) => {
      set({ storageFacilityStateWarning: value });
    },
  };
};
